import React from 'react';
import { Link } from '@tanstack/react-router';

interface VariantSelectProps {
  variant: 'memory' | 'sprk';
  errors?: any;
  register: Function;
};

const MemoryVariantSelect: React.FC<VariantSelectProps> = ({ variant, errors, register }) => {
  return (
    <div className="memory-variant-select-container inner">
      <div className="memory-variant-select-header">
        <div className="page-eyebrow">
          <wa-avatar initials="1" />
          What would you like to create?
        </div>
      </div>
      {errors.variant && (
        <div className="error-message">
          {errors.variant.message}
        </div>
      )}
      <div className="wa-cluster wa-align-items-stretch memory-variant-select">
        <div className="memory-variant-type-select-item">
          <label>
            <input
              type="radio"
              value="sprk"
              defaultChecked={variant === 'sprk'}
              {...register('variant')}
            />
            <div className="memory-variant-type-option">
              <div className="memory-variant-type-label">
                <h5><i className="fa-solid fa-bolt" /> SPRK</h5>
                <span>Capture a thought, feeling, or moment - and share it if you choose</span>
              </div>
            </div>
          </label>
          </div>
        <div className="memory-variant-type-select-item">
          <label>
            <input
              type="radio"
              value="memory"
              defaultChecked={variant === 'memory'}
              {...register('variant')}
            />
            <div className="memory-variant-type-option">
              <div className="memory-variant-type-label">
                <h5><i className="fa-regular fa-table-layout" /> Memory</h5>
                <span>Preserve one meaningful memory through words, photos, audio, or video</span>
              </div>
            </div>
          </label>
        </div>
        <div className="memory-variant-type-select-item">
          <Link to="/timelines/create" className="memory-variant-select-link">
            <div className="memory-variant-type-option">
              <div className="memory-variant-type-label">
                <h5><i className="fa-regular fa-list-timeline" /> Timeline</h5>
                <span>Connect memories into a larger story that can grow over time and through others</span>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default MemoryVariantSelect;
